import { render } from "./NewRequest.vue?vue&type=template&id=13e446de&scoped=true"
import script from "./NewRequest.vue?vue&type=script&lang=js"
export * from "./NewRequest.vue?vue&type=script&lang=js"

import "./NewRequest.vue?vue&type=style&index=0&id=13e446de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13e446de"]])

export default __exports__